import styled, { css } from "styled-components";

export const AgentNoteWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 2.4rem;
  gap: 2.4rem;
  background: #fffbeb;
  box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.36);
  backdrop-filter: blur(4.8rem);

  ${({ anchor }) =>
    anchor === "left"
      ? css`
          border-radius: 0 0.8rem 0.8rem 0;
        `
      : anchor === "right"
      ? css`
          border-radius: 0.8rem 0 0 0.8rem;
        `
      : anchor === "center"
      ? css`
          border-radius: 0.8rem;
        `
      : css`
          border-radius: 0 0 0.8rem 0.8rem;
        `}
`;

export const AgentNoteContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: #111827;
  gap: 0.2rem;
`;

export const AgentNoteTitle = styled.div`
  font-weight: 600;
  font-size: 1.4rem;
  color: #111827;
  line-height: 2rem;
`;

export const AgentNoteContent = styled.div`
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.6rem;
`;

export const AvatarWrapper = styled.div`
  height: 4.8rem;
  width: 4.8rem;
`;
